import { render, staticRenderFns } from "./Helicopters_list.vue?vue&type=template&id=3766fa92&scoped=true&"
import script from "./Helicopters_list.vue?vue&type=script&lang=js&"
export * from "./Helicopters_list.vue?vue&type=script&lang=js&"
import style0 from "./Helicopters_list.vue?vue&type=style&index=0&id=3766fa92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766fa92",
  null
  
)

export default component.exports